
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.833","height":"37.637"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 723","transform":"translate(-594.587 -1505.552)","fill":"#088dd1"}},[_c('path',{attrs:{"data-name":"Path 6907","d":"M609.463 1541.011l1.979 2.177h-11.084l1.979-2.177h1.734l-.038.771-.031.632.633-.005 2.541-.021.623-.005-.068-1.373z","fill-rule":"evenodd"}}),_c('circle',{attrs:{"data-name":"Ellipse 79","cx":"1.282","cy":"1.282","r":"1.282","transform":"translate(604.617 1516.815)"}}),_c('path',{attrs:{"data-name":"Path 6908","d":"M594.587 1522.12l.79 1.755 9.068-4.588a1.869 1.869 0 01-.4-.917z","fill-rule":"evenodd"}}),_c('path',{attrs:{"data-name":"Path 6909","d":"M618.42 1521.526l-.728 1.977-10.257-4.316a1.874 1.874 0 00.345-1.042z","fill-rule":"evenodd"}}),_c('path',{attrs:{"data-name":"Path 6910","d":"M606.912 1505.552h-2.061l.488 10.751a1.89 1.89 0 011.086-.011z","fill-rule":"evenodd"}}),_c('path',{attrs:{"data-name":"Path 6911","d":"M605.97 1517.72h-.146l-1.145 23.032-.053 1.06 2.541-.021-.052-1.039z","fill-rule":"evenodd"}})])])
          )
        }
      }
    